import {cs} from "../../../../../react/chain-services";
import {UseState} from "../../../../../react/use-state";
import {fragments} from "../../../../../react/fragments";
import {Static2} from "../../../../../react/static-2";
import {Interval} from "../../../../../react/interval";
import {Invoke} from "../../../../../react/invoke";
import {TimeoutAction} from "../../../../../react/timeout-action";

export const DivCollapser = ({expandedBottomPadding=0, collapsedHeight, next}) => cs(
    ["outerRef", (_, next) => Static2({next})],
    ["innerRef", (_, next) => Static2({next})],
    ["innerHeight", (_, next) => UseState({next})],
    ["state", (_, next) => UseState({initValue: "collapsed", next})],
    ({state, innerRef, outerRef, innerHeight}) => fragments(
        next({
            collapsed: state.value === "collapsed",
            collapsing: state.value === "collapsing",
            expanded: state.value === "expanded",
            expanding: state.value === "expanding",
            state: state.value,
            outerRef: outerRef.set,
            innerRef: innerRef.set,
            toggle: () => state.change((s) => (s === "collapsed" || s === "collapsing") ? (
                "expanding-start"
            ) : (
                "collapsing-start"
            )),
            pointless: innerHeight.value != null && innerHeight.value <= collapsedHeight,
            outerHeight: state.value === "expanded" ? (
                null
            ) : state.value === "collapsed" ? (
                collapsedHeight
            ) : state.value === "expanding-start" ? (
                outerRef.get().getBoundingClientRect().height
            ) : state.value === "expanding" ? (
                innerRef.get().getBoundingClientRect().height + expandedBottomPadding
            ) : state.value === "collapsing-start" ? (
                outerRef.get().getBoundingClientRect().height
            ) : state.value === "collapsing" && (
                collapsedHeight
            ),
        }),

        StateTransition({state}),


        Interval({
            delay: 1000,
            props: innerHeight,
            fn: ({getLatestProps}) => {
                const dom = innerRef.get();
                if (!dom) {
                    return;
                }
                const innerHeight = getLatestProps();
                const height1 = dom.getBoundingClientRect().height;
                if (height1 !== innerHeight.value) {
                    innerHeight.onChange(height1);
                }
            },
        })
    )
);

const StateTransition = ({state}) => fragments(

    state.value === "expanding-start" ? (
        Invoke({
            fn: () => state.onChange("expanding"),
        })
    ) : state.value === "collapsing-start" && (
        TimeoutAction({
            delay: 10,
            // action: () => {},
            action: () => state.onChange("collapsing"),
        })
    ),

    state.value === "expanding" ? (
        TimeoutAction({
            delay: 300,
            action: () => state.onChange("expanded"),
        })
    ) : state.value === "collapsing" && (
        TimeoutAction({
            delay: 300,
            action: () => state.onChange("collapsed"),
        })
    ),
);